import { render, staticRenderFns } from "./confirmInfo.vue?vue&type=template&id=7673d4b2&scoped=true&"
import script from "./confirmInfo.vue?vue&type=script&lang=js&"
export * from "./confirmInfo.vue?vue&type=script&lang=js&"
import style0 from "./confirmInfo.vue?vue&type=style&index=0&id=7673d4b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7673d4b2",
  null
  
)

export default component.exports